
/**
*	Easy IM*MEDIA - Funzioni di gestione delle Single
*/

require ('lightgallery.js');
import 'lightgallery.js/dist/css/lightgallery.min.css';

/**
*	Funzione di init lightgallery
*
*	@return {void}
*/
const initLightgallery = () =>
{   
    let lightgalleryWrap = document.querySelector('.single #immagini .lightgallery');

    if (!lightgalleryWrap) return;


    lightGallery(lightgalleryWrap, {
        thumbnail: false,
        animateThumb: false,
        showThumbByDefault: false,
        download: false,
        hideBarsDelay: 1000000000,
        closable: false,
        zoom: false,
        fullScreen: false,
        autoplayControls: false,
        counter: false,
        hash: false,
        escKey: true,
        keyPress: true,
        loop: false,
        mode: 'lg-fade',
        selector: '.it-single-slide-wrapper'
    });
}


/**
*	Funzione di init per tutte le funzioni delle Single
*
*	@return {void}
*/
const initSinglePages = () =>
{
    initLightgallery();
}

export default initSinglePages;
